import api from './api';
import { SolicitudAseo, ActualizarSolicitudAseo, ApiResponse } from '../types';

export const solicitudAseoService = {
  getAll: async (): Promise<SolicitudAseo[]> => {
    const response = await api.get<SolicitudAseo[]>('/solicitudes');
    return response.data;
  },

  update: async (id: number, data: ActualizarSolicitudAseo): Promise<SolicitudAseo> => {
    const response = await api.put<SolicitudAseo>(`/solicitudes/${id}`, data);
    return response.data;
  },

  delete: async (id: number): Promise<ApiResponse<void>> => {
    const response = await api.delete<ApiResponse<void>>(`/solicitudes/${id}`);
    return response.data;
  },
};

